/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowUiAuthLoginIcon20Light = forwardRef('ArrowUiAuthLoginIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M8 2.5a.5.5 0 0 1 .5-.5H15a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3H8.5a.5.5 0 0 1 0-1H15a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H8.5a.5.5 0 0 1-.5-.5Z" }),
        React.createElement("path", { d: "M11.784 9H1.5a.5.5 0 0 0 0 1h10.284l-3.248 3.247a.5.5 0 1 0 .707.707l3.273-3.272a1.672 1.672 0 0 0 0-2.365L9.243 5.044a.5.5 0 0 0-.707.707L11.784 9Z" })));
});
